import { NgModule } from '@angular/core';
import { hasCustomClaim, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './core/layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './core/layouts/auth/auth-layout.component';
import { BootstrapComponent } from './session/bootstrap/bootstrap.component';
import { loggedInGuard2 } from './core/guards';
import { LandingComponent } from './pages/landing/landing.component';

const adminOnly = () => hasCustomClaim('isAdmin');
const redirectUnauthenticatedToLogin = () => redirectUnauthorizedTo(['/bootstrap']);

@NgModule({
    imports: [
        RouterModule.forRoot(([
            {
                path: '',
                redirectTo: 'bootstrap',
                pathMatch: 'full'
            },
            {
                path: 'bootstrap',
                component: BootstrapComponent,
            },
            {
                path: 'landing',
                component: LandingComponent,
            },
            {
                path: 'manage',
                component: AdminLayoutComponent,
                children: [
                    {
                        path: 'account-setup',
                        loadChildren: () => import('./pages/account-setup/account-setup.module').then(m => m.AccountSetupModule),
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'enterprise-account-setup',
                        loadChildren: () => import('./pages/enterprise-account-setup/enterprise-account-setup.module').then(m => m.EnterpriseAccountSetupModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    /*{
                        path: 'trial-account-setup',
                        loadChildren: () => import('./pages/trial-account-setup/trial-account-setup.module').then(m => m.TrialAccountSetupModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },*/
                    {
                        path: 'invited-setup',
                        loadChildren: () => import('./pages/invited-setup/invited-setup.module').then(m => m.InvitedSetupModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    /*{
                        path: 'trial-users',
                        loadChildren: () => import('./pages/trial-users/trial-users.module').then(m => m.TrialUsersModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },*/
                    {
                        path: 'upgrade-account',
                        loadChildren: () => import('./pages/upgrade-account/upgrade-account.module').then(m => m.UpgradeAccountModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    /*{
                        path: 'leads',
                        loadChildren: () => import('./pages/leads/leads.module').then(m => m.LeadsModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },*/
                    {
                        path: 'statements',
                        loadChildren: () => import('./pages/statements/statements.module').then(m => m.StatementsModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'proposals',
                        loadChildren: () => import('./pages/proposals/proposals.module').then(m => m.ProposalsModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'merchants',
                        loadChildren: () => import('./pages/merchants/merchants.module').then(m => m.MerchantsModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'merchant/:merchantId/statement',
                        loadChildren: () => import('./pages/statement/statement.module').then(m => m.StatementModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'merchant/:merchantId/proposal',
                        loadChildren: () => import('./pages/proposal/proposal.module').then(m => m.ProposalModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'change-password',
                        loadChildren: () => import('./pages/user-change-password/user-change-password.module').then(m => m.UserChangePasswordModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'impersonate',
                        loadChildren: () => import('./pages/impersonate/impersonate.module').then(m => m.ImpersonateModule),
                        // canActivate: [loggedInGuard2, AdminGuard],
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: adminOnly
                        }
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
                        // canActivate: [loggedInGuard2, AdminGuard],
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: adminOnly
                        }
                    },
                    {
                        path: 'self-service-reviews',
                        loadChildren: () => import('./pages/self-service-reviews/self-service-reviews.module').then(m => m.SelfServiceReviewsModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'organization-settings',
                        loadChildren: () => import('./pages/organization-settings/organization-settings.module').then(m => m.OrganizationSettingsModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'billing',
                        loadChildren: () => import('./pages/billing/billing.module').then(m => m.BillingModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'support',
                        loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule),
                        canActivate: [loggedInGuard2],
                        data: {
                            authGuardPipe: redirectUnauthenticatedToLogin
                        }
                    },
                    {
                        path: 'user-settings',
                        loadChildren: () => import('./pages/user-settings/user-settings.module').then(m => m.UserSettingsModule),
                        canActivate: [loggedInGuard2]
                    }
                ]
            },
            {
                path: '',
                component: AuthLayoutComponent,
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./session/session.module').then(m => m.SessionModule)
                    }
                ]
            },
            {
                path: '**',
                redirectTo: '404'
            }
        ] as Routes), {})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
